// removed by extract-text-webpack-plugin
module.exports = {"practice-insurer-tooltip":"practice-insurer-tooltip","practiceInsurerTooltip":"practice-insurer-tooltip","tooltip-inner":"tooltip-inner","tooltipInner":"tooltip-inner","tooltip-arrow":"tooltip-arrow","tooltipArrow":"tooltip-arrow"};


//////////////////
// WEBPACK FOOTER
// ./components/profile-right-section/src/styles/external.scss
// module id = 80
// module chunks = 0